<template>
  <div class="liu pos-manage businesser">
    <!-- 页面头部 -->
    <mt-header fixed title="重置登录密码" class="title2">
      <mt-button slot="left" icon="back" @click="onBackBtnClick">返回</mt-button>
    </mt-header>
    <!-- 页面主体 -->
    <div class="scroll-container" :style="customScrollHeight">
      <!-- 上部账号信息 -->
      <div class="form bn-form mt-15">
        <!-- 标题 -->
        <div class="title bn-form-title bn-radius-top">
          <span>账号信息</span>
        </div>
        <!-- 登录密码 -->
        <div class="row bn-form-row">
          <div class="item">
            <div class="label">
              <span>{{ data.userPwd1.label }}</span>
            </div>
            <div class="content">
              <input class="pwd" :type="pwd1Type" v-model="data.userPwd1.value" :placeholder="data.userPwd1.placeholder" @keyup="onUserPwd1Input">
              <div class="scan" @click="onPwd1EyeClick">
                <svg-icon :icon-class="pwd1Eye" class-name="cur-icon"></svg-icon>
              </div>
            </div>
          </div>
        </div>
        <!-- 登录密码确认 -->
        <div class="row bn-form-row bn-radius-bottom">
          <div class="item">
            <div class="label">
              <span>{{ data.userPwd2.label }}</span>
            </div>
            <div class="content">
              <input class="pwd" :type="pwd2Type" v-model="data.userPwd2.value" :placeholder="data.userPwd2.placeholder" @keyup="onUserPwd2Input">
              <div class="scan" @click="onPwd2EyeClick">
                <svg-icon :icon-class="pwd2Eye" class-name="cur-icon"></svg-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 提交按钮 -->
      <div class="btn">
        <mt-button type="primary" size="large" @click="onAddSubmitClick">
          保存
        </mt-button>
      </div>
    </div>
  </div>
</template>

<script>
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { CusToast, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { controlLicenseNoInput } from '@/utils/format';
import { validatePassword } from '@/utils/validate';
import { UpdateSalesmanPassWord } from '@/api/customer';

export default {
  name: 'BusinesserEditPwd',
  data() {
    return {
      pwd1Eye: 'hide_money',
      pwd1Type: 'password',
      pwd2Eye: 'hide_money',
      pwd2Type: 'password',
      data: {
        userPwd1: { label: '登录密码', value: '', placeholder: '请设置6位以上数字或字母' },
        userPwd2: { label: '登录密码', value: '', placeholder: '请确认登录密码' },
      },
    };
  },
  computed: {
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
  },
  methods: {
    // 验证当前页面数据合法性
    validatePageData(callback) {
      const userPwd1Err = validatePassword(this.data.userPwd1.value);
      const userPwd2Err = this.data.userPwd2.value !== this.data.userPwd1.value ? 1 : 0;

      const errResult1 = !userPwd1Err && !userPwd2Err;

      if (errResult1) {
        callback && callback();
      } else {
        if (userPwd1Err === 1) {
          CusToast(`${this.data.userPwd1.label}不能为空`);
          return;
        }
        if (userPwd1Err === 2) {
          CusToast(`${this.data.userPwd1.label}必须是6位以上数字/字母`);
          return;
        }
        if (userPwd1Err === 3) {
          CusToast(`${this.data.userPwd1.label}不能是重复的数字`);
          return;
        }
        if (userPwd1Err === 4) {
          CusToast(`${this.data.userPwd1.label}不能是连续的数字`);
          return;
        }
        if (userPwd2Err) {
          CusToast(`两次密码输入的不一致`);
          return;
        }
      }
    },
    // 通过接口重置密码
    updateSalesmanPassWord(callback) {
      CusLoadingOpen();
      const data = {
        passWord: this.data.userPwd2.value,
        salesmanId: this.$route.query.id,
      };
      UpdateSalesmanPassWord(data)
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              callback && callback();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 返回单击事件
    onBackBtnClick() {
      this.$router.go(-1);
    },
    // 登录密码输入事件
    onUserPwd1Input() {
      this.data.userPwd1.value = controlLicenseNoInput(this.data.userPwd1.value);
    },
    // 登录密码确认输入事件
    onUserPwd2Input() {
      this.data.userPwd2.value = controlLicenseNoInput(this.data.userPwd2.value);
    },
    // 密码1眼睛点击事件
    onPwd1EyeClick() {
      if (this.pwd1Eye === 'hide_money') {
        this.pwd1Eye = 'show_money';
        this.pwd1Type = 'text';
      } else {
        this.pwd1Eye = 'hide_money';
        this.pwd1Type = 'password';
      }
    },
    // 密码2眼睛点击事件
    onPwd2EyeClick() {
      if (this.pwd2Eye === 'hide_money') {
        this.pwd2Eye = 'show_money';
        this.pwd2Type = 'text';
      } else {
        this.pwd2Eye = 'hide_money';
        this.pwd2Type = 'password';
      }
    },
    // 业务员添加提交按钮点击事件
    onAddSubmitClick() {
      this.$nextTick(() => {
        this.validatePageData(() => {
          this.updateSalesmanPassWord(() => {
            CusToast('密码修改成功', 1800);
            setTimeout(() => {
              this.$router.go(-1);
            }, 1900);
          });
        });
      });
    },
  },
};
</script>

